export const SUPPORTED_EXTENSIONS_OLD = [
    'pdf',
    'txt',
    'xml',
    'png',
    'jpg',
    'jpeg',
];

export const MS_OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx'];

// Keep in sync with the list of supported extensions on the backend side
export const CONVERT_TO_PDF_EXTENSIONS = [...MS_OFFICE_EXTENSIONS, 'txt'];

export const SUPPORTED_EXTENSIONS = [
    ...SUPPORTED_EXTENSIONS_OLD,
    ...MS_OFFICE_EXTENSIONS,
];

export const ES_MAX_DOCUMENTS_COUNT_RESULT = 10_000;
